import { render, staticRenderFns } from "./RegistryActionTargetPicker.vue?vue&type=template&id=2b76b929"
import script from "./RegistryActionTargetPicker.vue?vue&type=script&lang=js"
export * from "./RegistryActionTargetPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b76b929')) {
      api.createRecord('2b76b929', component.options)
    } else {
      api.reload('2b76b929', component.options)
    }
    module.hot.accept("./RegistryActionTargetPicker.vue?vue&type=template&id=2b76b929", function () {
      api.rerender('2b76b929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryActionTargetPicker.vue"
export default component.exports